<mp-detail-headline [typeConfig]="typeConfig"></mp-detail-headline>
<mp-detail-verbrauch-graph [data]="werte" [typeConfig]="typeConfig"></mp-detail-verbrauch-graph>
